import React from 'react';
import styled from 'styled-components/macro';

export const Wrapper = styled.svg`
  textPath {
    text-transform: uppercase;
    font-weight: bold;
    font-size: 9rem;
    letter-spacing: 2.9rem;
  }
`;

const CircleCiderText = React.forwardRef((
  { }, ref: React.ForwardedRef<SVGSVGElement>
) => (
  <Wrapper ref={ref} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <path id="circle" d="M 50, 50 m -37, 0 a 37,37 0 1,1 74,0 a 37,37 0 1,1 -74,0" />
    </defs>

    <text>
      <textPath href="#circle">
        Sparkling Cider · 100% Premium ·
      </textPath>
    </text>
  </Wrapper>
));

export default CircleCiderText;